import { Link } from "@tanstack/react-router";
import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BUSINESS, CONTACT_PATH, routeTo } from "@/lib/site";
import { Reveal } from "../Reveal";
import { PHOTO_SIZES, PHOTOS } from "../images";

export function ExtendedStaysSection() {
  const photo = PHOTOS.parkModelCarport;

  return (
    <section
      className="relative isolate overflow-hidden bg-forest-deep py-24 text-cream sm:py-28 lg:py-32"
      aria-labelledby="extended-title"
    >
      <img
        src={photo.src}
        srcSet={photo.srcSet}
        sizes={PHOTO_SIZES.fullBleed}
        alt=""
        width={photo.width}
        height={photo.height}
        loading="lazy"
        decoding="async"
        className="absolute inset-0 -z-10 size-full object-cover"
        aria-hidden="true"
      />
      <div
        className="absolute inset-0 -z-10 bg-[linear-gradient(100deg,oklch(0.259_0.042_163.6/0.94)_0%,oklch(0.259_0.042_163.6/0.78)_55%,oklch(0.259_0.042_163.6/0.62)_100%)]"
        aria-hidden="true"
      />

      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-10">
        <Reveal className="max-w-2xl">
          <p className="eyebrow text-sand">Stay a Little Longer</p>
          <h2
            id="extended-title"
            className="mt-5 text-balance font-display text-3xl leading-[1.1] sm:text-4xl lg:text-[3rem]"
          >
            Flexible Options for Seasonal and Working Guests
          </h2>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-cream/85 sm:text-lg">
            <p>
              Amigo Inn &amp; RV Park welcomes snowbirds, seasonal travelers, corporate guests,
              energy workers, and visitors completing longer work assignments in the region.
            </p>
            <p>
              RV sites and furnished accommodations may be available for weekly, monthly, or
              seasonal stays. Guests interested in longer stays should contact the park to discuss
              their needs and confirm current availability.
            </p>
          </div>

          <div className="mt-9 flex flex-wrap items-center gap-4">
            <Button asChild variant="book" size="cta">
              <Link to={routeTo(CONTACT_PATH)}>
                Ask About Extended Stays <ArrowRight aria-hidden="true" />
              </Link>
            </Button>
            <a href={BUSINESS.phoneHref} className="link-underline text-sm font-semibold text-sand">
              <Phone className="size-4" aria-hidden="true" /> Call {BUSINESS.phone}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
